import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, isRTL } from "@/i18n/translations";

const LangContext = createContext(null);

const STORAGE_KEY = "cs_lang";

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
    const nav = (window.navigator?.language || "en").toLowerCase();
    if (nav.startsWith("pt")) return "pt";
    if (nav.startsWith("ar")) return "ar";
    return "en";
  });

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    const html = document.documentElement;
    html.setAttribute("lang", lang);
    html.setAttribute("dir", isRTL(lang) ? "rtl" : "ltr");
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.en,
      rtl: isRTL(lang),
    }),
    [lang]
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
